import { render, staticRenderFns } from "./BindList.vue?vue&type=template&id=2caed056&scoped=true"
import script from "./BindList.vue?vue&type=script&lang=js"
export * from "./BindList.vue?vue&type=script&lang=js"
import style0 from "./BindList.vue?vue&type=style&index=0&id=2caed056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caed056",
  null
  
)

export default component.exports